// src/components/common/MaintenancePage.jsx
import React from 'react';
import { FaTools, FaWhatsapp } from 'react-icons/fa';
import './MaintenancePage.css';

const MaintenancePage = () => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-content">
        <div className="maintenance-icon"><FaTools /></div>
        <h1>We'll be right back</h1>
        <p>Our store is currently undergoing maintenance. We're working hard to get things back up and running — please check back shortly.</p>
        <a href="https://wa.me/923001234567" target="_blank" rel="noopener noreferrer" className="maintenance-whatsapp-btn">
          <FaWhatsapp /> Contact us on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default MaintenancePage;